/**
 * Remove Cart Item Use Case
 */

import { ICartService } from '@/domain/services/cart.service.interface';
import { CartEntity } from '@/domain/entities/cart.entity';

export interface RemoveCartItemInput {
  cartToken: string;
  productId: string;
  variantId: string;
}

export interface RemoveCartItemOutput {
  cart: CartEntity;
}

export class RemoveCartItemUseCase {
  constructor(private readonly cartService: ICartService) {}

  async execute(input: RemoveCartItemInput): Promise<RemoveCartItemOutput> {
    if (!input.cartToken) {
      throw new Error('Cart token is required');
    }

    if (!input.productId) {
      throw new Error('Product ID is required');
    }

    if (!input.variantId) {
      throw new Error('Variant ID is required');
    }

    const cart = await this.cartService.removeCartItem(
      input.cartToken,
      input.productId,
      input.variantId
    );

    return { cart };
  }
}

